module.exports = __webpack_public_path__ + "static/use-case-5-content-4-0f58bb855d1b439636cc1df0ea9f5676.png";